import {useCallback} from "react";
import {useResource} from "./baseHooks";
import {
    AggregationFunction,
    previewReport,
    ReportExecutionResult,
    ReportPreviewRequest, VisualizationConfig
} from "../api/ReportApi";
import {AttributeFilter} from "../api/EmployeeApi";
import {DateRange} from "@react-types/calendar";


export const useReportPreview = (
    entity: string,
    groupingAttribute: string,
    aggregationFunction: AggregationFunction,
    visualization: VisualizationConfig,
    attributeFilters?: AttributeFilter[],
    fromTo?: DateRange,
    groupingNestedAttribute?: string
) => {

    const fetch = useCallback(async (): Promise<ReportExecutionResult> => {

        const requestData: ReportPreviewRequest = {
            groupingEntity: entity,
            groupingAttribute: groupingAttribute,
            groupingNestedAttribute: groupingNestedAttribute,
            aggregationFunction: aggregationFunction,
            attributeFilters: attributeFilters,
            visualization: visualization,
            from: fromTo?.start.toString(),
            to: fromTo?.end.toString()
        };

        const response = await previewReport(requestData);
        return response.data!;

    }, [groupingAttribute, groupingNestedAttribute, aggregationFunction, attributeFilters]);

    const {
        data: previewResult,
        loading,
        error,
        reload
    } = useResource(fetch);

    return { previewResult, loading, error, reload };
};

export default useReportPreview;
